let fitmentData = getFitmentData() || {
  currentVehicle: {},
  dropdownData: {},
  lastUpdated: null,
};

let currentSelectedVehicle = fitmentData.currentVehicle;

const modal = document.getElementById("fitment_modal");
const btn = document.getElementById("fitment_btn");
const span = document.getElementsByClassName("close")[0];

btn.onclick = function () {
  modal.style.display = "block";

  window.kortx("ktrack", "submitLead", {
    contentId: "Lead",
    contentType: "Select my Ride",
    kid: "35071488$1728522", // DO NOT EDIT
  });
};

span.onclick = function () {
  modal.style.display = "none";
  resetFormState();
  if (
    (document.URL.includes("collections") ||
      document.URL.includes("search?q=")) &&
    isEmpty(fitmentData.currentVehicle)
  ) {
    location.reload();
  }
};

function openFitmentModal() {
  modal.style.display = "block";
}

function externalSidebarToggle(event) {
  event.stopPropagation();
  const sidebar = document.getElementById("collection-attribute-sidebar");

  if (sidebar.style.width === "350px") {
    sidebar.style.width = "0px";
  } else {
    sidebar.style.width = "350px";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
      resetFormState();
      if (
        (document.URL.includes("collections") ||
          document.URL.includes("search?q=")) &&
        isEmpty(fitmentData.currentVehicle)
      ) {
        location.reload();
      }
    }

    if (event.target == modalMobile) {
      modalMobile.style.display = "none";
      if (
        (document.URL.includes("collections") ||
          document.URL.includes("search?q=")) &&
        isEmpty(fitmentData.currentVehicle)
      ) {
        location.reload();
      }
    }
  };
});

function saveFitmentData(nextFitmentData = fitmentData) {
  localStorage.setItem('fitmentData', JSON.stringify(nextFitmentData))
}

function getFitmentData() {
  const storedData = localStorage.getItem("fitmentData");

  const emptyFitment = {
    currentVehicle: {},
    dropdownData: {},
    lastUpdated: null,
  }; 

  if (!storedData) {
    saveFitmentData(emptyFitment);
    return emptyFitment;
  }

  const parsedData = JSON.parse(storedData);
  const now = Date.now();
  const threeDaysInMs = 3 * 24 * 60 * 60 * 1000;

  if (
    parsedData.lastUpdated &&
    now - parsedData.lastUpdated < threeDaysInMs
  ) {
    return parsedData;
  }

  // expired
  saveFitmentData(emptyFitment);
  return emptyFitment;
}

async function processFitments(currentSelectedVehicle) {
  let param = "";
  let info = "";

  for (const [k, v] of Object.entries(currentSelectedVehicle)) {
    if (k === "year") {
      const data = await getFitments("");
      if (Object.keys(data.result).length > 0) {
        makeFitmentSelectShared(
          Object.keys(data.result)[0],
          data.result.year.reverse(),
          v
        );
      }
      param = k + "=" + v;
    } else {
      const data = await getFitments(param);
      if (
        Object.keys(data.result).length > 0 &&
        Object.keys(data.result)[0] !== "sku"
      ) {
        makeFitmentSelectShared(
          Object.keys(data.result)[0],
          data.result[Object.keys(data.result)[0]],
          v
        );
      }
      param += "&" + k + "=" + v;
    }

    info += v + " ";
  }

  fitmentData.currentVehicle = currentSelectedVehicle;
  saveFitmentData();

  document.querySelector(".fitment_info").textContent = info;
  document.querySelector(".fitment_info_container").style.display = "flex";
  document.querySelector(".fitment_shop_btn").removeAttribute("disabled");
  document.querySelector(".fitment_clear_btn").style.display = "block";
}

if (!isEmpty(currentSelectedVehicle)) {
  document.querySelector(".fitment_header").style.display = "none";
  processFitments(currentSelectedVehicle);
} else {
  document.querySelector(".fitment_info_container").style.display = "none";
  document.querySelector(".fitment_header").style.display = "block";
  getFitments("").then((data) => {
    if (Object.keys(data.result).length > 0) {
      makeFitmentSelectShared(
        Object.keys(data.result)[0],
        data.result.year.reverse()
      );
    }
  });
}

function isEmpty(obj) {
  for (const prop in obj) {
    if (Object.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return true;
}

async function getFitments(param) {
  const store_id = "crawltek";
  let url = `https://fitmentapi.azurewebsites.net/api/ymm?store_id=${store_id}`;

  if (param) {
    if (!param.startsWith("&")) {
      param = "&" + param;
    }
    url += param;
  }

  // Check if we have cached data for this param
  if (fitmentData.dropdownData[param]) {
    return { result: fitmentData.dropdownData[param] };
  }

  const res = await fetch(url, { method: "GET" });
  const data = await res.json();

  // Cache the result
  fitmentData.dropdownData[param] = data.result;
  fitmentData.lastUpdated = new Date().getTime();

  return data;
}

function removeDuplicates(arr) {
  const uniqueLowercaseValues = [];
  const filteredArray = [];

  arr.forEach((item) => {
    const lowercaseItem = item.toString().toUpperCase();

    if (!uniqueLowercaseValues.includes(lowercaseItem)) {
      uniqueLowercaseValues.push(lowercaseItem);
      filteredArray.push(item);
    }
  });

  return filteredArray;
}

function makeFitmentSelectShared(id, optionArray, v, isMobile = false) {
  const suffix = isMobile ? "_mobile" : "";
  const optionClass = isMobile ? "fitment_option_mobile" : "fitment_option";
  const selectClass = isMobile ? "fitment_select_mobile" : "fitment_select";
  const containerClass = isMobile
    ? ".select_container_mobile"
    : ".select_container";

  if (id === "submodel" && optionArray.length > 0) {
    optionArray.push("(All Others)");
  }
  const filteredOptions = removeDuplicates(optionArray);
  if (filteredOptions.length > 1) {
    if (id == "year" || id == "make" || id == "model") {
      let html = "";
      filteredOptions.forEach((option) => {
        if (id === "year") {
          html +=
            `<option class="${optionClass}" ` +
            (parseInt(option) === parseInt(v) ? "selected" : "") +
            ">" +
            option +
            "</option>";
        } else {
          html +=
            `<option class="${optionClass}" ` +
            (option === v ? "selected" : "") +
            ">" +
            option +
            "</option>";
        }
      });
      document
        .getElementById(id + suffix)
        .insertAdjacentHTML("beforeend", html);
      document.getElementById(id + suffix).removeAttribute("disabled");
    } else {
      let html =
        `<select id="${id}${suffix}" class="${selectClass} select__select">` +
        "<option selected hidden>" +
        (id == "drive_type"
          ? "Drive Type"
          : id == "fuel_type"
          ? "Fuel Type"
          : id.charAt(0).toUpperCase() + id.slice(1)) +
        "</option>";
      filteredOptions.forEach((option) => {
        html +=
          `<option class="${optionClass}" ` +
          (option === v ? "selected" : "") +
          ">" +
          option +
          "</option>";
      });
      document
        .querySelector(containerClass)
        .insertAdjacentHTML("beforeend", html + "</select>");
    }
  } else {
    if (id == "year" || id == "make" || id == "model") {
      let html = "";
      html +=
        `<option class="${optionClass}" selected>` +
        filteredOptions[0] +
        "</option>";

      document
        .getElementById(id + suffix)
        .insertAdjacentHTML("beforeend", html);
      document.getElementById(id + suffix).removeAttribute("disabled");
    } else {
      let html =
        `<select id="${id}${suffix}" class="${selectClass} select__select">` +
        "<option selected hidden>" +
        (id == "drive_type"
          ? "Drive Type"
          : id == "fuel_type"
          ? "Fuel Type"
          : id.charAt(0).toUpperCase() + id.slice(1)) +
        "</option>";
      html +=
        `<option class="${optionClass}" selected>` +
        filteredOptions[0] +
        "</option>";
      document
        .querySelector(containerClass)
        .insertAdjacentHTML("beforeend", html + "</select>");
    }

    if (!v) {
      var event = new Event("change", {
        bubbles: true,
        cancelable: true,
      });
      document.getElementById(id + suffix).dispatchEvent(event);
    }
  }
}

function makeFitmentParam(type) {
  let param = "";
  let isAdding = true;
  let keyArray = [];
  for (const [k, v] of Object.entries(currentSelectedVehicle)) {
    if (isAdding) {
      param += k + "=" + v + "&";
      keyArray.push(k);
    } else {
      delete currentSelectedVehicle[k];
    }
    if (k == type) {
      isAdding = false;
    }
  }
  document.querySelectorAll(".fitment_select").forEach((element) => {
    if (!keyArray.includes(element.id)) {
      let id = element.id;
      if (id == "make" || id == "model") {
        document
          .getElementById(id)
          .querySelectorAll('option[class="fitment_option"]')
          .forEach((option) => option.remove());
        document.getElementById(id).setAttribute("disabled", true);
      } else {
        element.remove();
      }
    }
  });

  return param.slice(0, -1);
}

function resetFormState() {
  currentSelectedVehicle = {};
  document.querySelectorAll(".fitment_select").forEach((element) => {
    const id = element.id;
    if (id === "year" || id === "make" || id === "model") {
      // Reset to default option
      element.value = element.options[0].value;
      // Remove 'selected' attribute from all options except the first one
      Array.from(element.options).forEach((option, index) => {
        if (index === 0) {
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
      // Disable make and model dropdowns
      if (id !== "year") {
        element.setAttribute("disabled", true);
      }
      // Remove all options except the first one for make and model
      if (id !== "year") {
        Array.from(
          element.querySelectorAll("option:not(:first-child)")
        ).forEach((option) => option.remove());
      }
    } else {
      // Remove any additional dropdowns (e.g., submodel, drive_type, fuel_type)
      element.remove();
    }
  });
  document.querySelector(".fitment_shop_btn").setAttribute("disabled", true);
  document.querySelector(".fitment_clear_btn").style.display = "none";
  // No need to re-fetch year data as we're keeping it
}

$(document).on("change", ".fitment_select", function () {
  const validSelectArr = [
    "year",
    "make",
    "model",
    "submodel",
    "drive_type",
    "fuel_type",
  ];
  const id = $(this).attr("id");

  if (validSelectArr.includes(id)) {
    currentSelectedVehicle[id] = $(this).val();

    getFitments(makeFitmentParam(id)).then((data) => {
      const resultKeys = Object.keys(data.result);
      const resultLength = resultKeys.length;

      if (
        resultLength > 0 &&
        resultKeys[0] !== "doors" &&
        resultKeys[0] !== "type" &&
        data.result[resultKeys[0]].length > 0
      ) {
        makeFitmentSelectShared(resultKeys[0], data.result[resultKeys[0]]);
        document
          .querySelector(".fitment_shop_btn")
          .setAttribute("disabled", true);
        document.querySelector(".fitment_clear_btn").style.display = "none";
      } else {
        document.querySelector(".fitment_shop_btn").removeAttribute("disabled");
        document.querySelector(".fitment_clear_btn").style.display = "block";
      }
    });
  }
});

document.addEventListener("click", function (event) {
  if (event.target.matches(".popular_vehicles a")) {
    document
      .querySelectorAll(".popular_collection_details")
      .forEach((element) => element.classList.add("hidden"));

    const vehicle = event.target.textContent;
    document
      .querySelectorAll(".popular_collection_details")
      .forEach((element) => {
        if (vehicle.split(" ").every((i) => element.classList.contains(i))) {
          element.classList.remove("hidden");
        }
      });

    document
      .querySelectorAll(".popular_vehicles a")
      .forEach((element) => element.classList.remove("active"));
    event.target.classList.add("active");
  }
});

document
  .querySelector(".fitment_shop_btn")
  .addEventListener("click", function () {
    let info = "";
    Object.entries(currentSelectedVehicle).forEach(([k, v]) => {
      info += v + " ";
    });

    document.querySelector(".fitment_info").textContent = info;
    const header = document.querySelector(".collection_details_header h1");
    if (header) header.textContent = info + " All Products";
    document.querySelector(".fitment_info_container").style.display = "flex";
    document.querySelector(".fitment_header").style.display = "none";
    document.querySelector(".fitment_header_mobile strong").textContent = info;
    document.getElementById("fitment_btn_mobile").textContent = "Change";

    fitmentData.currentVehicle = currentSelectedVehicle;
    saveFitmentData();

    modal.style.display = "none";

    const urlConditions =
      !document.URL.includes("/collections/") &&
      !document.URL.includes("/products/") &&
      !document.URL.includes("search?q=");

    if (urlConditions) {
      window.location.href = "/pages/product-fitment-search";
    } else if (
      document.URL.includes("collections") ||
      document.URL.includes("search?q=")
    ) {
      location.reload();
    }
  });

function clearFitmentData() {
  fitmentData = {
    currentVehicle: {},
    dropdownData: {},
    lastUpdated: null,
  };
  currentSelectedVehicle = {};
  saveFitmentData();

  document.querySelector(".fitment_info").textContent = "";
  document.querySelector(".fitment_info_container").style.display = "none";
  document.querySelector(".fitment_header_mobile strong").textContent =
    "Shop by vehicle";
  document.getElementById("fitment_btn_mobile").textContent =
    "+ select my ride";
  document.querySelector(".fitment_header").style.display = "block";

  document.querySelectorAll(".fitment_select").forEach((element) => {
    const id = element.id;

    if (id == "year" || id == "make" || id == "model") {
      document
        .getElementById(id)
        .querySelectorAll('option[class="fitment_option"]')
        .forEach((option) => option.remove());
      document.getElementById(id).setAttribute("disabled", true);
    } else {
      element.remove();
    }
  });

  getFitments("").then((data) => {
    const resultKeys = Object.keys(data.result);

    if (resultKeys.length > 0) {
      makeFitmentSelectShared(resultKeys[0], data.result.year.reverse());
    }
  });

  document.querySelector(".fitment_shop_btn").setAttribute("disabled", true);
  document.querySelector(".fitment_clear_btn").style.display = "none";
}

document
  .querySelector(".btn_container p")
  .addEventListener("click", clearFitmentData);

document.querySelector(".fitment_info").addEventListener("click", function () {
  modal.style.display = "block";
});

document.querySelector(".fitment_clear").addEventListener("click", function () {
  clearFitmentData();

  if (
    document.URL.includes("collections") ||
    document.URL.includes("search?q=")
  ) {
    location.reload();
  }
});

// Divider for sticky-header.js

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector(".section-header-navigation");
    this.headerIsAlwaysSticky = this.getAttribute("data-sticky-type");

    this.headerBounds = {};

    this.setHeaderHeight();

    window
      .matchMedia("(max-width: 990px)")
      .addEventListener("change", this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add("shopify-section-header-sticky");
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.header.offsetHeight}px`
    );
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      if (this.preventHide) return;
      this.header.classList.add("scrolled-past-header");
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");

      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove("scrolled-past-header");
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky != null) {
      if (this.headerIsAlwaysSticky === "always") {
        this.header.classList.add("shopify-section-header-sticky");
        return;
      } else {
        this.header.classList.add(
          "shopify-section-header-hidden",
          "shopify-section-header-sticky"
        );
        this.header.classList.remove("shopify-section-header-show");
      }
    }
    this.closeMenuDisclosure();
  }

  reveal() {
    if (this.headerIsAlwaysSticky != null) {
      if (this.headerIsAlwaysSticky === "always") {
        this.header.classList.add("shopify-section-header-sticky", "animate");
        return;
      } else {
        this.header.classList.add(
          "shopify-section-header-sticky",
          "shopify-section-header-show",
          "animate"
        );
        this.header.classList.remove("shopify-section-header-hidden");
      }
    }
  }

  reset() {
    if (this.headerIsAlwaysSticky != null) {
      if (this.headerIsAlwaysSticky === "always") {
        this.header.classList.add("shopify-section-header-sticky", "animate");
        return;
      } else {
        this.header.classList.remove(
          "shopify-section-header-hidden",
          "shopify-section-header-show",
          "shopify-section-header-sticky",
          "animate"
        );
      }
    }
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll("details-disclosure");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }
}

customElements.define("sticky-header", StickyHeader);

// const modal = document.getElementById('fitment_modal')
// const btn = document.getElementById('fitment_btn')
// const span = document.getElementsByClassName('close')[0]
// let currentSelectedVehicle = localStorage.getItem('fitmentData')
//   ? JSON.parse(localStorage.getItem('fitmentData'))
//   : {}

// btn.onclick = function () {
//   modal.style.display = 'block'

//   window.kortx('ktrack', 'submitLead', {
//     contentId: 'Lead',
//     contentType: 'Select my Ride',
//     kid: '35071488$1728522', // DO NOT EDIT
//   })
// }

// span.onclick = function () {
//   modal.style.display = 'none'
//   if (
//     (document.URL.includes('collections') ||
//       document.URL.includes('search?q=')) &&
//     !localStorage.getItem('fitmentData')
//   ) {
//     location.reload()
//   }
// }

// function openFitmentModal() {
//   modal.style.display = 'block'
// }

// function externalSidebarToggle(event) {
//   event.stopPropagation()
//   const sidebar = document.getElementById('collection-attribute-sidebar')

//   if (sidebar.style.width === '350px') {
//     sidebar.style.width = '0px'
//   } else {
//     sidebar.style.width = '350px'
//   }
// }

// document.addEventListener('DOMContentLoaded', function () {
//   window.onclick = function (event) {
//     if (event.target == modal) {
//       modal.style.display = 'none'
//       if (
//         (document.URL.includes('collections') ||
//           document.URL.includes('search?q=')) &&
//         !localStorage.getItem('fitmentData')
//       ) {
//         location.reload()
//       }
//     }

//     if (event.target == modalMobile) {
//       modalMobile.style.display = 'none'
//       if (
//         (document.URL.includes('collections') ||
//           document.URL.includes('search?q=')) &&
//         !localStorage.getItem('fitmentData')
//       ) {
//         location.reload()
//       }
//     }
//   }
// })

// async function processFitments(currentSelectedVehicle) {
//   let param = ''
//   let info = ''

//   for (const [k, v] of Object.entries(currentSelectedVehicle)) {
//     if (k === 'year') {
//       const data = await getFitments('')
//       if (Object.keys(data.result).length > 0) {
//         makeFitmentSelect(
//           Object.keys(data.result)[0],
//           data.result.year.reverse(),
//           v
//         )
//       }
//       param = k + '=' + v
//     } else {
//       const data = await getFitments(param)
//       if (
//         Object.keys(data.result).length > 0 &&
//         Object.keys(data.result)[0] !== 'sku'
//       ) {
//         makeFitmentSelect(
//           Object.keys(data.result)[0],
//           data.result[Object.keys(data.result)[0]],
//           v
//         )
//       }
//       param += '&' + k + '=' + v
//     }

//     info += v + ' '
//   }

//   document.querySelector('.fitment_info').textContent = info
//   document.querySelector('.fitment_info_container').style.display = 'flex'
//   document.querySelector('.fitment_shop_btn').removeAttribute('disabled')
//   document.querySelector('.fitment_clear_btn').style.display = 'block'
// }

// if (!isEmpty(currentSelectedVehicle)) {
//   document.querySelector('.fitment_header').style.display = 'none'
//   processFitments(currentSelectedVehicle)
// } else {
//   document.querySelector('.fitment_info_container').style.display = 'none'
//   document.querySelector('.fitment_header').style.display = 'block'
//   getFitments('').then((data) => {
//     if (Object.keys(data.result).length > 0) {
//       makeFitmentSelect(Object.keys(data.result)[0], data.result.year.reverse())
//     }
//   })
// }

// function isEmpty(obj) {
//   for (const prop in obj) {
//     if (Object.hasOwnProperty.call(obj, prop)) {
//       return false
//     }
//   }
//   return true
// }

// async function getFitments(param) {
//   const store_id = 'crawltek';
//   let url = `https://fitmentapi.azurewebsites.net/api/ymm?store_id=${store_id}`;

//   // Ensure param starts with '&' if not empty
//   if (param) {
//     if (!param.startsWith('&')) {
//       param = '&' + param;
//     }
//     url += param;
//   }

//   const res = await fetch(url, { method: 'GET' });
//   return res.json();
// }

// function removeDuplicates(arr) {
//   const uniqueLowercaseValues = []
//   const filteredArray = []

//   arr.forEach((item) => {
//     const lowercaseItem = item.toString().toUpperCase()

//     if (!uniqueLowercaseValues.includes(lowercaseItem)) {
//       uniqueLowercaseValues.push(lowercaseItem)
//       filteredArray.push(item)
//     }
//   })

//   return filteredArray
// }

// function makeFitmentSelect(id, optionArray, v) {
//   const filteredOptions = removeDuplicates(optionArray)
//   if (filteredOptions.length > 1) {
//     if (id == 'year' || id == 'make' || id == 'model') {
//       let html = ''
//       filteredOptions.forEach((option) => {
//         if (id === 'year') {
//           html +=
//             '<option class="fitment_option" ' +
//             (option.toString() === v.toString() ? 'selected' : '') +
//             '>' +
//             option +
//             '</option>'
//         } else {
//           html +=
//             '<option class="fitment_option" ' +
//             (option === v ? 'selected' : '') +
//             '>' +
//             option +
//             '</option>'
//         }
//       })
//       document.getElementById(id).insertAdjacentHTML('beforeend', html)
//       document.getElementById(id).removeAttribute('disabled')
//     } else {
//       let html =
//         '<select id="' +
//         id +
//         '" class="fitment_select select__select">' +
//         '<option selected hidden>' +
//         (id == 'drive_type'
//           ? 'Drive Type'
//           : id == 'fuel_type'
//           ? 'Fuel Type'
//           : id.charAt(0).toUpperCase() + id.slice(1)) +
//         '</option>'
//       filteredOptions.forEach((option) => {
//         html +=
//           '<option class="fitment_option" ' +
//           (option === v ? 'selected' : '') +
//           '>' +
//           option +
//           '</option>'
//       })
//       document
//         .querySelector('.select_container')
//         .insertAdjacentHTML('beforeend', html + '</select>')
//     }
//   } else {
//     if (id == 'year' || id == 'make' || id == 'model') {
//       let html = ''
//       if (id === 'year') {
//         html +=
//           '<option class="fitment_option" selected>' +
//           filteredOptions[0] +
//           '</option>'
//       } else {
//         html +=
//           '<option class="fitment_option" selected>' +
//           filteredOptions[0] +
//           '</option>'
//       }

//       $('#' + id).append(html)
//       $('#' + id).attr('disabled', false)
//     } else {
//       let html =
//         '<select id="' +
//         id +
//         '" class="fitment_select select__select">' +
//         '<option selected hidden>' +
//         (id == 'drive_type'
//           ? 'Drive Type'
//           : id == 'fuel_type'
//           ? 'Fuel Type'
//           : id.charAt(0).toUpperCase() + id.slice(1)) +
//         '</option>'
//       html +=
//         '<option  class="fitment_option" selected>' +
//         filteredOptions[0] +
//         '</option>'
//       $('.select_container').append(html + '</select>')
//     }

//     if (!v) {
//       var event = new Event('change', {
//         bubbles: true,
//         cancelable: true,
//       })
//       document.getElementById(id).dispatchEvent(event)
//     }
//   }
// }

// function makeFitmentParam(type) {
//   let param = ''
//   let isAdding = true
//   let keyArray = []
//   for (const [k, v] of Object.entries(currentSelectedVehicle)) {
//     if (isAdding) {
//       param += k + '=' + v + '&'
//       keyArray.push(k)
//     } else {
//       delete currentSelectedVehicle[k]
//     }
//     if (k == type) {
//       isAdding = false
//     }
//   }
//   document.querySelectorAll('.fitment_select').forEach((element) => {
//     if (!keyArray.includes(element.id)) {
//       let id = element.id
//       if (id == 'make' || id == 'model') {
//         document
//           .getElementById(id)
//           .querySelectorAll('option[class="fitment_option"]')
//           .forEach((option) => option.remove())
//         document.getElementById(id).setAttribute('disabled', true)
//       } else {
//         element.remove()
//       }
//     }
//   })

//   return param.slice(0, -1)
// }

// $(document).on('change', '.fitment_select', function () {
//   const validSelectArr = [
//     'year',
//     'make',
//     'model',
//     'submodel',
//     'drive_type',
//     'fuel_type',
//   ]
//   const id = $(this).attr('id')

//   if (validSelectArr.includes(id)) {
//     currentSelectedVehicle[id] = $(this).val()
//     getFitments(makeFitmentParam(id)).then((data) => {
//       const resultKeys = Object.keys(data.result)
//       const resultLength = resultKeys.length

//       if (
//         resultLength > 0 &&
//         resultKeys[0] !== 'doors' &&
//         resultKeys[0] !== 'type' &&
//         data.result[resultKeys[0]].length > 0
//       ) {
//         makeFitmentSelect(resultKeys[0], data.result[resultKeys[0]])
//         document
//           .querySelector('.fitment_shop_btn')
//           .setAttribute('disabled', true)
//         document.querySelector('.fitment_clear_btn').style.display = 'none'
//       } else {
//         document.querySelector('.fitment_shop_btn').removeAttribute('disabled')
//         document.querySelector('.fitment_clear_btn').style.display = 'block'
//       }
//     })
//   }
// })

// document.addEventListener('click', function (event) {
//   if (event.target.matches('.popular_vehicles a')) {
//     document
//       .querySelectorAll('.popular_collection_details')
//       .forEach((element) => element.classList.add('hidden'))

//     const vehicle = event.target.textContent
//     document
//       .querySelectorAll('.popular_collection_details')
//       .forEach((element) => {
//         if (vehicle.split(' ').every((i) => element.classList.contains(i))) {
//           element.classList.remove('hidden')
//         }
//       })

//     document
//       .querySelectorAll('.popular_vehicles a')
//       .forEach((element) => element.classList.remove('active'))
//     event.target.classList.add('active')
//   }
// })

// document
//   .querySelector('.fitment_shop_btn')
//   .addEventListener('click', function () {
//     let info = ''
//     Object.entries(currentSelectedVehicle).forEach(([k, v]) => {
//       info += v + ' '
//     })

//     document.querySelector('.fitment_info').textContent = info
//     const header = document.querySelector('.collection_details_header h1')
//     if (header) header.textContent = info + ' All Products'
//     document.querySelector('.fitment_info_container').style.display = 'flex'
//     document.querySelector('.fitment_header').style.display = 'none'
//     document.querySelector('.fitment_header_mobile strong').textContent = info
//     document.getElementById('fitment_btn_mobile').textContent = 'Change'
//     localStorage.setItem('fitment', JSON.stringify(currentSelectedVehicle))
//     modal.style.display = 'none'

//     const urlConditions =
//       !document.URL.includes('/collections/') &&
//       !document.URL.includes('/products/') &&
//       !document.URL.includes('search?q=')

//     if (urlConditions) {
//       window.location.href = '/pages/product-fitment-search'
//     } else if (
//       document.URL.includes('collections') ||
//       document.URL.includes('search?q=')
//     ) {
//       location.reload()
//     }
//   })

// document
//   .querySelector('.btn_container p')
//   .addEventListener('click', function () {
//     currentSelectedVehicle = {}
//     localStorage.removeItem('fitment')
//     document.querySelector('.fitment_info').textContent = ''
//     document.querySelector('.fitment_info_container').style.display = 'none'
//     document.querySelector('.fitment_header_mobile strong').textContent =
//       'Shop by vehicle'
//     document.getElementById('fitment_btn_mobile').textContent =
//       '+ select my ride'
//     document.querySelector('.fitment_header').style.display = 'block'

//     document.querySelectorAll('.fitment_select').forEach((element) => {
//       const id = element.id

//       if (id == 'year' || id == 'make' || id == 'model') {
//         document
//           .getElementById(id)
//           .querySelectorAll('option[class="fitment_option"]')
//           .forEach((option) => option.remove())
//         document.getElementById(id).setAttribute('disabled', true)
//       } else {
//         element.remove()
//       }
//     })

//     getFitments('').then((data) => {
//       const resultKeys = Object.keys(data.result)

//       if (resultKeys.length > 0) {
//         makeFitmentSelect(resultKeys[0], data.result.year.reverse())
//       }
//     })

//     document.querySelector('.fitment_shop_btn').setAttribute('disabled', true)
//     document.querySelector('.fitment_clear_btn').style.display = 'none'
//   })

// document.querySelector('.fitment_info').addEventListener('click', function () {
//   modal.style.display = 'block'
// })

// document.querySelector('.fitment_clear').addEventListener('click', function () {
//   currentSelectedVehicle = {}
//   localStorage.removeItem('fitment')
//   document.querySelector('.fitment_info').textContent = ''
//   document.querySelector('.fitment_info_container').style.display = 'none'
//   document.querySelector('.fitment_header_mobile strong').textContent =
//     'Shop by vehicle'
//   document.getElementById('fitment_btn_mobile').textContent = '+ select my ride'
//   document.querySelector('.fitment_header').style.display = 'block'

//   document.querySelectorAll('.fitment_select').forEach((element) => {
//     const id = element.id

//     if (id == 'year' || id == 'make' || id == 'model') {
//       document
//         .getElementById(id)
//         .querySelectorAll('option[class="fitment_option"]')
//         .forEach((option) => option.remove())
//       document.getElementById(id).setAttribute('disabled', true)
//     } else {
//       element.remove()
//     }
//   })

//   getFitments('').then((data) => {
//     const resultKeys = Object.keys(data.result)

//     if (resultKeys.length > 0) {
//       makeFitmentSelect(resultKeys[0], data.result.year.reverse())
//     }
//   })

//   document.querySelector('.fitment_shop_btn').setAttribute('disabled', true)
//   document.querySelector('.fitment_clear_btn').style.display = 'none'

//   if (
//     document.URL.includes('collections') ||
//     document.URL.includes('search?q=')
//   ) {
//     location.reload()
//   }
// })

// class StickyHeader extends HTMLElement {
//   constructor() {
//     super()
//   }

//   connectedCallback() {
//     this.header = document.querySelector('.section-header-navigation')
//     this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type')

//     this.headerBounds = {}

//     this.setHeaderHeight()

//     window
//       .matchMedia('(max-width: 990px)')
//       .addEventListener('change', this.setHeaderHeight.bind(this))

//     if (this.headerIsAlwaysSticky) {
//       this.header.classList.add('shopify-section-header-sticky')
//     }

//     this.currentScrollTop = 0
//     this.preventReveal = false

//     this.onScrollHandler = this.onScroll.bind(this)
//     this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

//     this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
//     window.addEventListener('scroll', this.onScrollHandler, false)

//     this.createObserver()
//   }

//   setHeaderHeight() {
//     document.documentElement.style.setProperty(
//       '--header-height',
//       `${this.header.offsetHeight}px`
//     )
//   }

//   disconnectedCallback() {
//     this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
//     window.removeEventListener('scroll', this.onScrollHandler)
//   }

//   createObserver() {
//     let observer = new IntersectionObserver((entries, observer) => {
//       this.headerBounds = entries[0].intersectionRect
//       observer.disconnect()
//     })

//     observer.observe(this.header)
//   }

//   onScroll() {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop
//     if (
//       scrollTop > this.currentScrollTop &&
//       scrollTop > this.headerBounds.bottom
//     ) {
//       if (this.preventHide) return
//       this.header.classList.add('scrolled-past-header')
//       requestAnimationFrame(this.hide.bind(this))
//     } else if (
//       scrollTop < this.currentScrollTop &&
//       scrollTop > this.headerBounds.bottom
//     ) {
//       this.header.classList.add('scrolled-past-header')

//       if (!this.preventReveal) {
//         requestAnimationFrame(this.reveal.bind(this))
//       } else {
//         window.clearTimeout(this.isScrolling)

//         this.isScrolling = setTimeout(() => {
//           this.preventReveal = false
//         }, 66)

//         requestAnimationFrame(this.hide.bind(this))
//       }
//     } else if (scrollTop <= this.headerBounds.top) {
//       this.header.classList.remove('scrolled-past-header')
//       requestAnimationFrame(this.reset.bind(this))
//     }

//     this.currentScrollTop = scrollTop
//   }

//   hide() {
//     if (this.headerIsAlwaysSticky != null) {
//       if (this.headerIsAlwaysSticky === 'always') {
//         this.header.classList.add('shopify-section-header-sticky')
//         return
//       } else {
//         this.header.classList.add(
//           'shopify-section-header-hidden',
//           'shopify-section-header-sticky'
//         )
//         this.header.classList.remove('shopify-section-header-show')
//       }
//     }
//     this.closeMenuDisclosure()
//   }

//   reveal() {
//     if (this.headerIsAlwaysSticky != null) {
//       if (this.headerIsAlwaysSticky === 'always') {
//         this.header.classList.add('shopify-section-header-sticky', 'animate')
//         return
//       } else {
//         this.header.classList.add(
//           'shopify-section-header-sticky',
//           'shopify-section-header-show',
//           'animate'
//         )
//         this.header.classList.remove('shopify-section-header-hidden')
//       }
//     }
//   }

//   reset() {
//     if (this.headerIsAlwaysSticky != null) {
//       if (this.headerIsAlwaysSticky === 'always') {
//         this.header.classList.add('shopify-section-header-sticky', 'animate')
//         return
//       } else {
//         this.header.classList.remove(
//           'shopify-section-header-hidden',
//           'shopify-section-header-show',
//           'shopify-section-header-sticky',
//           'animate'
//         )
//       }
//     }
//   }

//   closeMenuDisclosure() {
//     this.disclosures =
//       this.disclosures || this.header.querySelectorAll('details-disclosure')
//     this.disclosures.forEach((disclosure) => disclosure.close())
//   }
// }

// customElements.define('sticky-header', StickyHeader)
